/**
 * API エラー（axios）からユーザー向けメッセージを取り出す。
 * バックエンドの HttpExceptionFilter は `{ messages, code, ... }` を返す。
 */
export const getApiErrorMessage = (e: any, fallback: string): string => {
  return e?.response?.data?.messages || fallback;
};

/** LIMIT_EXCEEDED（プラン上限超過）エラーかどうか。 */
export const isLimitExceeded = (e: any): boolean => {
  return e?.response?.data?.code === 'LIMIT_EXCEEDED';
};
